import React from 'react';
import { Typography } from '@mui/material';
import { isBOSC } from '../../../utils/share';
import { useStyles } from '../styles/quaterGoalStyles';

const QuarterGoal = () => {
  const classes = useStyles();

  if (!isBOSC()) return null;

  return (
    <div className={classes.root}>
      <Typography variant="subtitle2" gutterBottom className={classes.subtitle}>
        The Goal Of This Quarter
      </Typography>
      <div className={classes.marqueeContainer}>
        {/* <b className={classes.marqueeContent}>Streamline, Deliver And Succeed: A Quarter Of Transformation</b> */}
        <b className={classes.marqueeContent}>RISE 2025</b>
      </div>
    </div>
  );
};

export default QuarterGoal;
